module.exports = __webpack_public_path__ + "Wilson-43412f1a.png";